@if(!isCreate){
  <ejs-grid #grid
            class="grid-with-toolbar"
            width="100%"
            rowHeight="38"
            [dataSource]="data"
            [allowFiltering]='true'
            [filterSettings]='filterSettings'
            [allowSorting]='true'
            [pageSettings]='pageSettings'
            [allowPaging]='true'
            [editSettings]='editSettings'
            (actionComplete)="actionComplete($event)"
            (actionBegin)="actionBegin($event)"
            (dataBound)="dataBound()">
    <ng-template #toolbarTemplate let-data>
      <ejs-toolbar>
        <e-items>
          <e-item [text]="'i18n.domain.import-configuration.edit.response.add-configuration-dialog-title' | translate" prefixIcon='e-icons icon-add' (click)="onAdd()"></e-item>
        </e-items>
      </ejs-toolbar>
    </ng-template>
    <e-columns>
      <e-column field="id" [visible]="false" [isPrimaryKey]="true"></e-column>
      <e-column field="configurationName"
        headerText="{{'i18n.domain.export-configuration.configurations.overview.column-headers.name' | translate}}"
        clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{data.configurationName}} - {{getTransferTypeName(data.transferType) | translate}} ({{data.id}})
        </ng-template>
      </e-column>
      <e-column field="type"
        headerText="{{'i18n.domain.export-configuration.configurations.overview.column-headers.type' | translate}}"
        clipMode="EllipsisWithTooltip" width="110px">
        <ng-template #template let-data>
          {{getTypeName(data.type) | translate}}
        </ng-template>
      </e-column>
      <e-column headerText="" [commands]='gridCommands' width='120px'></e-column>
    </e-columns>
    <ng-template #editSettingsTemplate let-data>
      <app-configuration-forms-overview></app-configuration-forms-overview>
    </ng-template>
  </ejs-grid>
} @else {
  <div class="form-row row">
    <div class="form-group col-12">
      <div innerHTML="{{'i18n.domain.import-configuration.edit.response.create-information'| translate }}"></div>
    </div>
  </div>
}

@if(authService.isUserAdmin()){
  <ejs-dialog #loadTemplateDialog [isModal]="true" [showCloseIcon]="true" [visible]="false" (close)="templateDialogCancelClicked()" (open)="templateDialogOnOpen($event)">
    <ng-template #header>
      {{'i18n.domain.export-configuration.configurations.forms.email.template-selector-title' | translate}}
    </ng-template>

    <ng-template #content>
      <app-configuration-templates-overview #configTemplateOverview (rowDoubleClick)="templateSelectedAndClose($event)"
        (rowSelected)="templateSelected($event)" [configurationType]="selectedExportConfig?.type" [mode]="selectedExportConfig?.mode">
      </app-configuration-templates-overview>
    </ng-template>

    <ng-template #footerTemplate>
      <ng-container>
        <button class="e-control e-btn e-lib e-primary e-flat" (click)="templateDialogOkClicked()"
          [disabled]="!selectedExportTemplate">{{'i18n.shared.ok' | translate}}</button>
        <button class="e-control e-btn e-lib e-flat" (click)="templateDialogCancelClicked()">{{'i18n.shared.cancel' |
          translate}}</button>
      </ng-container>
    </ng-template>
  </ejs-dialog>
}
